var render, staticRenderFns
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5eda63a')) {
      api.createRecord('e5eda63a', component.options)
    } else {
      api.reload('e5eda63a', component.options)
    }
    
  }
}
component.options.__file = "src/pages/redirect/index.vue"
export default component.exports